import { render, staticRenderFns } from "./RegistAccountList.vue?vue&type=template&id=1b4e3c2d&scoped=true"
import script from "./RegistAccountList.vue?vue&type=script&lang=js"
export * from "./RegistAccountList.vue?vue&type=script&lang=js"
import style0 from "./RegistAccountList.vue?vue&type=style&index=0&id=1b4e3c2d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4e3c2d",
  null
  
)

export default component.exports